export default __webpack_public_path__ + "static/media/metodo.7d37263a.png";